<mat-card style="display: flex; background-color: transparent; justify-content: center; align-items: center" class="mat-elevation-z0">

  <mat-spinner strokeWidth="3" color="primary" mode="indeterminate"></mat-spinner>
<!--  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>-->

</mat-card>
